import * as React from 'react'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useQuery } from 'react-query'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'

export const BillToPostalCodeProvider: React.FC<IProviderProps> = ({
  render,
}) => {
  const { data, isFetching } = useQuery(
    ['filters', 'lead', 'billToPostalCode'],
    async (): Promise<IOption[]> => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'leads',
          'PostalCode',
        )}`,
      )

      const postalCodes: string[] = await result.json()

      const options: IOption[] = postalCodes
        .filter((v) => v !== '')
        .map((v) => ({
          value: v,
          label: v,
        }))

      return options
    },
  )

  return <>{render(data ?? [], isFetching)}</>
}
BillToPostalCodeProvider.displayName = 'BillToPostalCodeProvider'
